import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CommdocEditor.html?raw';
import lang from 'dojo/_base/lang';

import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _uiFrameMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import _GlobalSelectEntityDialogsMixin from '../../../moreCore/UI/Container/uiFrame';

import { TabContainer } from "../../../moreCore/_loadingHelpers/Tabbing";

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import PerformerContractEditor from './ClassEditors/PerformerContractEditor';
import ServiceContractEditor from './ClassEditors/ServiceContractEditor';
import DigitalSignatureEditor from '../../DigitalSignature/DigitalSignatureEditor';
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import Edit from '../../../moreCore/UI/Edit/Edit';
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { FileHelpers, StringHelpers } from "../../../more/Helpers";
import documentEditor from '../../fileEditor/documentEditor/documentEditor';
import { SignatureEntity } from "../../DigitalSignature/DigitalSignatureTypes";
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import Button from '../../../moreCore/UI/Button/Button';
import { GenericDialogTypes } from "../../../moreCore/UI/GenericDialog/GenericDialogTypes";

class CommdocEditor extends compose(_StatefulSection, _uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    classEditor: MdsLax<InstanceType<typeof PerformerContractEditor>> | MdsLax<InstanceType<typeof ServiceContractEditor>>;
    digitalSignatureEditor: MdsLax<InstanceType<typeof DigitalSignatureEditor>>;

    sectionDocInfo: HTMLDivElement;
    sectionEditor: MdsLax<InstanceType<typeof ExpandableSection>>;
    editorContainer: HTMLDivElement;

    sectionDigitalSignature: HTMLDivElement;
    expanderDigitalSignature: MdsLax<InstanceType<typeof ExpandableSection>>;

    //File table
    sectionFiles: HTMLDivElement;
    expanderFiles: MdsLax<InstanceType<typeof ExpandableSection>>;
    fileTable: MdsLax<InstanceType<typeof StaticTable>>;
    fileStore: MdsLax<InstanceType<typeof EntityStore<FileFinder.FileDescriptorWithBase64>>>;

    fileTableRowConfig: StaticTable.RowConfig = {
        headings: ["General_Label_Filename", "General_Label_CreationDate"],
        attributes: ["filename", "CreationDate"],
        colNamesInternal: ["filename", "CreationDate"]
    };

    fileTableLayout: StaticTable.Layout = {
        label: "fileTable",
        name: "fileTable",
        rows: [(this as any).fileTableRowConfig]
    }

    private _fileTableFormatter(cell: StaticTable.StaticTableCell<FileFinder.FileDescriptorWithBase64>): boolean {
        let name = cell.name;
        let node = cell.tableCellNode;
        let value = cell.value;


        switch (name) {

        }

        return false;
    }

    private _setupFileTable(): void {
        this.fileTable = new StaticTable();
        this.fileStore = new EntityStore();
        this.fileTable.setLayout(this.fileTableLayout);
        this.fileTable.setFormatter(this._fileTableFormatter);
        this.fileTable.addCustomRowActionButton("download", lang.hitch(this, this._onClickDownloadButton), "fas fa-download");
        this.fileTable.setupFromStore(this.fileStore);
        this.fileTable.placeAt(this.expanderFiles);
    }

    private _onClickDownloadButton(rowGroup: StaticTable.StaticTableRowGroup<FileFinder.FileDescriptorWithBase64>): void {
        let entity = rowGroup.entity;

        FileHelpers.provideFile(entity);
    }

    //Service Table
    sectionServicePositions: HTMLDivElement;
    expanderServicePositions: MdsLax<InstanceType<typeof ExpandableSection>>;
    servicePositionsTable: MdsLax<InstanceType<typeof StaticTable>>;
    servicePositionsStore: MdsLax<InstanceType<typeof EntityStore<VtCommpos>>>;

    btnTextServicePositionssReload: MdsLax<InstanceType<typeof Button>>;
    newServiceButton: MdsLax<InstanceType<typeof Button>>;

    servicePositionsTableRowConfig: StaticTable.RowConfig = {
        headings: ["General_Label_PositionsStatus", "General_Label_ServiceText"],
        attributes: ["ref_actual_pos_ev_serv_2.ref_ht_posevserv_vtcommpos.ref_pos_ev_serv_status.code", "service_txt"],
        bgColors: ["ref_actual_pos_ev_serv_2.ref_ht_posevserv_vtcommpos.ref_pos_ev_serv_status.coloration", null]
    };

    servicePositionsTableLayout: StaticTable.Layout = {
        label: "serviceTable",
        name: "serviceTable",
        rows: [(this as any).servicePositionsTableRowConfig]
    }

    private _servicePositionsTableFormatter(cell: StaticTable.StaticTableCell<FileFinder.FileDescriptorWithBase64>): boolean {
        let name = cell.name;
        let node = cell.tableCellNode;
        let value = cell.value;


        switch (name) {

        }

        return false;
    }

    private _setupServicePositionsTable(): void {
        this.servicePositionsTable = new StaticTable();
        this.servicePositionsStore = new EntityStore();
        this.servicePositionsStore.on("change", lang.hitch(this, this._onChangeServicePositionsStore));
        this.servicePositionsTable.setLayout(this.servicePositionsTableLayout);
        this.servicePositionsTable.setFormatter(this._servicePositionsTableFormatter);
        this.servicePositionsTable.setupFromStore(this.servicePositionsStore);
        this.servicePositionsTable.addDefaultRowActionButton("delete", null, lang.hitch(this, this._isDraft), true);
        this.servicePositionsTable.placeAt(this.expanderServicePositions);
    }

    private _onClickServicePositionsReloadButton(): void {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_Document__DocumentEditor_LoadVtCommposData",
            { ID: this.getAttributeValue("ID") },
            lang.hitch(this, this._onReloadServicePositionsResponse),
            lang.hitch(this, this._onReloadServicePositionsError)
        );
    }

    private _onReloadServicePositionsResponse(response: Array<VtCommpos>) {
        this.StandbyStop();
        this.servicePositionsStore.setup(response);
        this.setAttributeValue("servicePositionDiffData", null);
        this._setServicePositionExpanderMarking();
    }

    private _onReloadServicePositionsError(error) {
        this.StandbyStop()
        console.error(error);
    }

    private _onChangeServicePositionsStore(): void {
        let diffData = this.servicePositionsStore.getDiffData();
        this.setAttributeValue("servicePositionDiffData", diffData);
        this._setServicePositionExpanderMarking();
    }

    private _setServicePositionExpanderMarking(): void {
        let servicePositions = this.servicePositionsStore.getCurrentCompleteList();
        this.expanderServicePositions.setMarking((servicePositions && servicePositions.length > 0) ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _storeHasPosEvServ(entity: PosEvServ): boolean {
        let completeList = this.servicePositionsStore.getCurrentCompleteList();

        for (let vtPos of completeList) {
            //ref_pos_ev_serv kann auch null sein, wenn die zugehörige Leistungsbuchung bereits gelöscht ist
            if (vtPos.ref_actual_pos_ev_serv_2.ref_ht_posevserv_vtcommpos.ref_pos_ev_serv && vtPos.ref_actual_pos_ev_serv_2.ref_ht_posevserv_vtcommpos.ref_pos_ev_serv.ID === entity.ID) return true;
        }
        return false;
    }

    private _onClickNewServicePositionButton(evt: MouseEvent) {
        let menu = new FloatingMenu();
        menu.addEntry({
            callback: lang.hitch(this, this._onClickSelectServiceButton),
            label: "DocumentEditor_Label_Select",
            icon: "fas fa-hand-pointer"
        });

        menu.addEntry({
            callback: lang.hitch(this, this._onAutoSelectServiceButton),
            label: "DocumentEditor_Label_Auto",
            icon: "fas fa-recycle"
        });

        menu.open(evt);
    }

    private _addPosEvServToStore(posEvServ: PosEvServ, showError: boolean = true) {
        let fakeEntity: VtCommpos = {
            ID: StringHelpers.randomID(),
            $Displayname: "",
            Classname: "",
            ClassPrintname: "",
            ref_commdoc: this.getAttributeValue("ID"),
            ref_service: posEvServ.ref_service,
            service_txt: posEvServ.service_txt,
            ref_actual_pos_ev_serv_2: {
                ref_ht_posevserv_vtcommpos: {
                    $Displayname: "",
                    Classname: "",
                    ClassPrintname: "",
                    ID: StringHelpers.randomID(),
                    ref_pos_ev_serv: posEvServ,
                    ref_vt_commpos: null
                }
            }
        }
        if (!this._storeHasPosEvServ(posEvServ)) this.servicePositionsStore.addEntry(fakeEntity);
        else if (showError) this.showToast(this.translate("DocumentEditor_Warning_DuplicateService"), "fas fa-warning-triangle");
        
    }

    private _onClickSelectServiceButton(evt: MouseEvent) {
        this.loadSelectEntityDialog(evt, "selectService", lang.hitch(this, this._onSEDCallback), null, { entityId: this.entityId });
    }

    private _onAutoSelectServiceButton(evt: MouseEvent) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_GetAvailablePosEvServ", { entityId: this.entityId }, lang.hitch(this, this._onAutoSelectServicesResponse), lang.hitch(this, this._onAutoSelectServicesError));
    }

    private _onAutoSelectServicesResponse(response: ResultList<PosEvServ>) {
      
        this.StandbyStop();

        if (response?.entitylist?.length <= 0) {
            this.showToast(this.translate("DocumentEditor_Warning_NoAvailablePosEvServ"), "fas fa-exclamation");
            return;
        }

        for (let posEvServ of response.entitylist) {
            this._addPosEvServToStore(posEvServ.data, false);
        }
    }

    private _onAutoSelectServicesError(error) {
        this.StandbyStop();
        console.error(error);
    }


    //Text module table
    sectionTextModules: HTMLDivElement;
    expanderTextModules: MdsLax<InstanceType<typeof ExpandableSection>>;
    textModulesTable: MdsLax<InstanceType<typeof StaticTable>>;
    textModulesStore: MdsLax<InstanceType<typeof EntityStore<HtTextModuleCommdoc>>>;

    btnTextModulesReload: MdsLax<InstanceType<typeof Button>>;
    newTextModuleButton: MdsLax<InstanceType<typeof Button>>;

    textModulesTableRowConfig: StaticTable.RowConfig = {
        headings: ["General_Label_TextModule", "General_Label_Language"],
        attributes: ["ref_text_modul.description", "ref_text_modul.ref_language.code"],
    };

    textModulesTableLayout: StaticTable.Layout = {
        label: "textModuleTable",
        name: "textModuleTable",
        rows: [(this as any).textModulesTableRowConfig]
    }

    private _textModuleTableFormatter(cell: StaticTable.StaticTableCell<FileFinder.FileDescriptorWithBase64>): boolean {
        let name = cell.name;
        let node = cell.tableCellNode;
        let value = cell.value;


        switch (name) {

        }

        return false;
    }

    private _setupTextModuleTable(): void {
        this.textModulesTable = new StaticTable();
        this.textModulesStore = new EntityStore();
        this.textModulesStore.on("change", lang.hitch(this, this._onTextModuleStoreChange));
        this.textModulesTable.setLayout(this.textModulesTableLayout);
        this.textModulesTable.setFormatter(this._textModuleTableFormatter);
        this.textModulesTable.setupFromStore(this.textModulesStore);
        this.textModulesTable.addDefaultRowActionButton("delete", null, lang.hitch(this, this._isDraft), true);
        this.textModulesTable.setupRowSorting("order", null, lang.hitch(this, this._isDraft));
        this.textModulesTable.placeAt(this.expanderTextModules);
    }

    private _onClickTextModulesReloadButton(): void {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_Document__DocumentEditor_LoadHtTextModuleData",
            { ID: this.getAttributeValue("ID") },
            lang.hitch(this, this._onReloadTextModulesResponse),
            lang.hitch(this, this._onReloadTextModuleError)
        );
    }

    private _onReloadTextModulesResponse(response: Array<HtTextModuleCommdoc>) {
        this.StandbyStop();
        this.textModulesStore.setup(response);
        this.setAttributeValue("textModuleDiffData", null);
        this._setTextModuleExpanderMarking();
    }

    private _onReloadTextModuleError(error) {
        this.StandbyStop();
        console.error(error);
    }

    private _onTextModuleStoreChange(): void {
        let diffData = this.textModulesStore.getDiffData();
        this.setAttributeValue("textModuleDiffData", diffData);
        this._setTextModuleExpanderMarking();
    }

    private _setTextModuleExpanderMarking(): void {
        let textModules = this.textModulesStore.getCurrentCompleteList();
        this.expanderTextModules.setMarking((textModules && textModules.length > 0) ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _addTextModuleToStore(textModule: TextModule, showError: boolean = true) {
        let fakeEntity: HtTextModuleCommdoc = {
            $Displayname: "",
            Classname: "",
            ClassPrintname: "",
            ID: StringHelpers.randomID(),
            order: this.textModulesStore.getCurrentCompleteList().length,
            ref_commdoc: this.getAttributeValue("ID"),
            ref_text_modul: textModule
        }
        if (!this._storeHasTextModule(textModule)) {
            this.textModulesStore.addEntry(fakeEntity);
        }
        else if (showError) {
            this.showToast(this.translate("DocumentEditor_Warning_DuplicateTextModule"), "fas fa-warning-triangle");
        }
    }

    private _onClickNewTextModuleButton(evt: MouseEvent) {
        this.loadSelectEntityDialog(evt, "selectTextModule", lang.hitch(this, this._onSEDCallback));
    }

    private _storeHasTextModule(entity: TextModule): boolean {
        let completeList = this.textModulesStore.getCurrentCompleteList();

        for (let htTextmodule of completeList) {
            if (htTextmodule.ref_text_modul.ID === entity.ID) return true;
        }

        return false;
    }



    private inputDocNo: MdsLax<InstanceType<typeof Edit>>;
    private inputStatus: MdsLax<InstanceType<typeof SearchSelect>>;
    private inputRefVTFile: MdsLax<InstanceType<typeof Edit>>;

    private inputEditorAddress: MdsLax<InstanceType<typeof HintBox>>;

    private documentClassname: string;
    private _targetTabContainer: MdsLax<InstanceType<typeof TabContainer>> = null;
    private _targetNode: HTMLElement = null;


    setup(classname: string, documentID?: string, tabContainer?: MdsLax<InstanceType<typeof TabContainer>>, node?: HTMLElement): void {
        let heading;
        node ? this._targetNode = node : this._targetNode = null;
        tabContainer ? this._targetTabContainer = tabContainer : this._targetTabContainer = null;

        if (this.classEditor) {
            this.classEditor.destroy();
            this.classEditor = null;
        }

        if (!classname) {
            console.error("Error: No classname for new entity provided");
            return;
        }
        this.documentClassname = classname;

        switch (this.documentClassname) {
            case "performer_contract":
                this.classEditor = new PerformerContractEditor();
                this.classEditor.setStartupState("loading");
                this.classEditor.on("changed", lang.hitch(this, this._onChangeClassEditor));
                break;
            default:
                this.hideNode(this.sectionEditor.domNode);
                this.hideNode(this.editorContainer);
                console.warn("No editor defined for this document class");
                break;
        }

        if (this.classEditor) this.sectionEditor.setMarking(ExpandableSectionMarkings.hasContent);

        if (!documentID) {
            
            this.internalName = "DocumentEditor_Editor_New";
            let newEntity: any = {
                ID: "",
                $Displayname: "",
                Classname: this.documentClassname,
                ClassPrintname: "",
                isNew: true
            }

            this.setData(newEntity);
            heading = this.translate("Document_Heading_NewDocumentEditor");
            this.classEditor.setup(newEntity, null, this.sectionEditor.containerNode);
        } else {

            this._setupFileTable();
            this._setupServicePositionsTable();
            this._setupTextModuleTable();

            this.internalName = "DocumentEditor_Editor_" + documentID;

            this._loadEntity(documentID);
        }

        if (this._targetNode) this.show("node", this._targetNode, heading);
        else if (this._targetTabContainer) this.show("tab", heading, this._targetTabContainer.name);
        else this.show("dlg", heading);

        this.createDefaultButton("save", lang.hitch(this, this._onClickSave), false, "primary");
    }

    //LOAD
    private _loadEntity(entityId: string): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        this.RequestManager.callfunction(
            "Webtool_API_Document__DocumentEditor_LoadEntity",
            { ID: entityId, classname: this.documentClassname },
            lang.hitch(this, this._onLoadEntityResponse),
            lang.hitch(this, this._onLoadEntityError));
    }

    private _onLoadEntityResponse(response: DocumentEntity): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        response.isNew = false;
        this.setData(response);
        if (this.classEditor) this.classEditor.setup(response, null, this.sectionEditor.containerNode);
        this._createFrameHeading(`${response.ClassPrintname}: ${response.$Displayname}`);
    }

    private _onLoadEntityError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
    }

    //SAVE
    private _onClickSave(): void {
        let isValid = this.checkMandatoryInputs();
        let isValidClassEditor = this.classEditor ? this.classEditor.checkMandatoryInputs() : true;

        if (!isValid || !isValidClassEditor) {
            this.showToast({
                title: "General_Label_Error",
                iconClass: "fas fa-exclamation-triangle",
                message: "General_Error_InvalidData"
            });
            return;
        }

        this.StandbyStart();
        this._deactivateDataButtons(true, true);

        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        let isNew = this.getAttributeValue("is_new");
        let changedData = this.getChangedData();

        this.RequestManager.callfunction(
            "Webtool_API_Document__DocumentEditor_SaveEntity",
            { ID: entityId, Classname: classname, is_new: isNew, changedData: changedData },
            lang.hitch(this, this._onSaveResponse),
            lang.hitch(this, this._onSaveError));
    }

    private _onSaveResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("changed");
        this.emit("saved");
        this.showToast("Editor_Success_Save", "fas fa-check");
        this._loadEntity(response.entityId);
    }

    private _onSaveError(error): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast("Editor_Error_Save", "fas fa-warning-triangle");
    }

    //ROLLBACK
    private _onClickRollback(e: MouseEvent): void {
        this.rollback();
    }

    //RELOAD
    private _onClickReload(e: MouseEvent): void {
        let entity = this.getAttributeValue("___root");
        this._loadEntity(entity.ID);
    }

    //DELETE
    private _onClickDelete(e: MouseEvent): void {
        this.StandbyStart();
        this._deactivateDataButtons(true, true);
        let entityId = this.getAttributeValue("ID");
        let classname = this.getAttributeValue("Classname");
        this.RequestManager.callfunction(
            "Webtool_API_Document__DocumentEditor_DeleteEntity",
            { ID: entityId, Classname: classname },
            lang.hitch(this, this._onDeleteResponse),
            lang.hitch(this, this._onDeleteError));
    }

    private _onDeleteResponse(response): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.debug(response);
        this.emit("deleted");
        this.close();
        this.showToast("Editor_Success_Delete", "fas fa-check");
    }

    private _onDeleteError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        this._deactivateDataButtons(false, true);
        console.error(error);
        this.showToast({ title: "Editor_Error_Delete", iconClass: "fas fa-warning-triangle", message: error?.Message, timeout: 5000 });
    }


    //BUTTONS
    private _deactivateDataButtons(deactivate: boolean, deactivateAll?: boolean): void {
        this.requestContextButtonDisable("save", deactivate);
        this.requestContextButtonDisable("rollback", deactivate);
        if (deactivateAll) {
            this.requestContextButtonDisable("delete", deactivate);
            this.requestContextButtonDisable("reload", deactivate);
        }
    }


    //STATEFULSECTION
    protected onDirtyChange(newState: boolean) {
        this._deactivateDataButtons(!newState);
        this.setDirtyMarker(newState);
        this._handleDocumentButtons();
    }

    protected _onChanged(attribute: string, value: any) {
        switch (attribute) {

        }
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.setStartupState("ready");

        let isNew = this.getAttributeValue("is_new");
        if (!isNew) {
            this.createDefaultButton("delete", lang.hitch(this, this._onClickDelete), true, "secondary");
            this.createDefaultButton("rollback", lang.hitch(this, this._onClickRollback), false, "secondary");
            this.createDefaultButton("reload", lang.hitch(this, this._onClickReload), true, "primary");
            this.changeInternalName("DocumentEditor_Editor_" + this.getAttributeValue("ID"));
            this.setTitles(`${this.getAttributeValue("ClassPrintname")}: ${this.getAttributeValue("$Displayname")}`);
        }

        let signatureEntity = this.getAttributeValue("ref_signature_entity");
        if (signatureEntity && this.hasFeature("DigitalSignature/DigitalSignatureEditor")) {
            if (this.digitalSignatureEditor) {
                this.digitalSignatureEditor.destroy();
                this.digitalSignatureEditor = null;
            }
            this.hideNode(this.sectionDigitalSignature, false);
            this.expanderDigitalSignature.setMarking(ExpandableSectionMarkings.hasContent);
            this.digitalSignatureEditor = new DigitalSignatureEditor();
            this.digitalSignatureEditor.setup(signatureEntity, null, this.expanderDigitalSignature.containerNode);
            this.setAttributeValue("signatureEditorDiffData", null);
            this.digitalSignatureEditor.on("changed", lang.hitch(this, this._onChangeDigitalSignatureEditor));          
        } else {
            if (this.digitalSignatureEditor) {
                this.digitalSignatureEditor.destroy();
                this.digitalSignatureEditor = null;
            }
        }

        let files = this.getAttributeValue("files");
        this.fileStore.setup(files);
        this.expanderFiles.setMarking((files && files.length > 0) ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        let services = this.getAttributeValue("EL_vt_commpos_commdoc");
        this.servicePositionsStore.setup(services);
        this._setServicePositionExpanderMarking();
        this.setAttributeValue("servicePositionDiffData", null);

        let textModules = this.getAttributeValue("EL_ht_text_modul_commdocs_commdoc");
        this.textModulesStore.setup(textModules);
        this._setTextModuleExpanderMarking();
        this.setAttributeValue("textModuleDiffData", null);

        this._deactivateDataButtons(true);
        this._handleDocumentButtons();
        this._handleReadonlyState();
    }

    private _isDraft(): boolean {
        let isDraft = this.getAttributeValue("is_draft");
        return isDraft;
    }

    private _handleDocumentButtons(): void {
        let file = this.getAttributeValue("ref_vt_files");
        let signatureEntity = this.getAttributeValue("ref_signature_entity");
        let status = this.getAttributeValue("ref_doc_status");
        let isNotRelevant = this.getAttributeValue("is_notRelevant");
        let isDraft = this.getAttributeValue("is_draft");
        let isCreated = this.getAttributeValue("is_created");
        let isClosed = this.getAttributeValue("is_closed");
        let isArchived = this.getAttributeValue("is_archived");

        this.addButtonMenuEx({
            internalName: "editDocumentMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-edit",
            label: this.translate("DocumentEditor_Label_EditDocumentMenu"),
            parentGroupName: null
        });

        this.addButtonMenuEx({
            internalName: "documentStatusMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-file-alt",
            label: this.translate("DocumentEditor_Label_DocumentStatusMenu"),
            parentGroupName: null
        });

        this.addButtonMenuEx({
            internalName: "documentSignatureMenu",
            bIsGroupNextLevel: true,
            iconClass: "fas fa-file-signature",
            label: this.translate("DocumentEditor_Label_DocumentSignatureMenu"),
            parentGroupName: null
        });

        if (file && !signatureEntity && this.hasFeature("DigitalSignature/DigitalSignatureEditor")) {
            this.addButtonEx(
                {
                    internalName: "createSignature",
                    callback: lang.hitch(this, this._onClickCreateSignatureObject),
                    label: 'Document_Label_CreateSignatureObject',
                    iconClass: 'fas fa-signature',
                    bCloseOnClick: false,
                    position: "secondary",
                    groupname: "documentSignatureMenu"
                });
        } else {
            this.requestContextButtonRemove("createSignature");
        }

        if (isDraft) {
            if (this.hasFeature("Document", "createDocument")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClickCreateCommdoc),
                        internalName: "createDocument",
                        label: this.translate("CommdocList_ButtonTitle_Create"),
                        iconClass: "fas fa-file-import",
                        bCloseOnClick: false,
                        enabled: isDraft && !this.isDirty(),
                        groupname: "editDocumentMenu",
                        position: "secondary",
                        order: 2
                    }
                );
            }

            if (this.hasFeature("documentEditor", "useInCommdoc")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClick_EditCommdoc),
                        internalName: "editFinalText",
                        label: this.translate("CommdocList_ButtonTitle_DocumentEditor"),
                        iconClass: "fas fa-pencil-ruler",
                        bCloseOnClick: false,
                        enabled: isDraft,
                        groupname: "editDocumentMenu",
                        position: "secondary",
                        order: 1
                    }
                );

                if (this.hasFeature("Document", "generateDraft")) {
                    this.addButtonEx(
                        {
                            callback: lang.hitch(this, this._onClickGenerateDraftCommdoc),
                            internalName: "generateDraft",
                            label: this.translate("CommdocList_ButtonTitle_GenerateDraft"),
                            iconClass: "fas fa-file-signature",
                            bCloseOnClick: false,
                            enabled: isDraft && !this.isDirty(),
                            groupname: "editDocumentMenu",
                            position: "secondary",
                            order: 0
                        }
                    );
                }


            }


        } else {
            this.requestContextButtonRemove("createDocument");
            this.requestContextButtonRemove("generateDraft");
            this.requestContextButtonRemove("editFinalText");
            this.requestContextButtonRemove("delete");
            if (this.newServiceButton && !this.newServiceButton._destroyed) this.UiModder.domConstruct.destroy(this.newServiceButton.domNode);
            if (this.newServiceButton && !this.newServiceButton._destroyed) this.UiModder.domConstruct.destroy(this.newTextModuleButton.domNode);
        }


        if (!isClosed && !isNotRelevant && !status?.is_finished && !isArchived) {
            if (this.hasFeature("Document", "closeDocument")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClickCloseCommdoc),
                        internalName: "closeDocument",
                        label: this.translate("CommdocList_ButtonTitle_Close"),
                        iconClass: "fas fa-ban",
                        bCloseOnClick: false,
                        enabled: !isClosed && !isNotRelevant && !status?.is_finished && !isArchived && !this.isDirty(),
                        groupname: "documentStatusMenu",
                        position: "secondary"
                    }
                );
            }
            if (this.hasFeature("Document", "archiveDocument")) {
                this.addButtonEx(
                    {
                        callback: lang.hitch(this, this._onClickArchiveCommdoc),
                        internalName: "archiveDocument",
                        label: this.translate("CommdocList_ButtonTitle_Archive"),
                        iconClass: "fas fa-archive",
                        bCloseOnClick: false,
                        enabled: !isClosed && !isNotRelevant && !status?.is_finished && !isArchived && !this.isDirty(),
                        groupname: "documentStatusMenu",
                        position: "secondary",
                    }
                );
            }
        } else {
            this.requestContextButtonRemove("closeDocument");
            this.requestContextButtonRemove("archiveDocument");
            this.requestContextButtonRemove("save");
            this.requestContextButtonRemove("rollback");
        }

        if (this.hasFeature("Document", "releaseIsFinished") && this.hasUserRole("Commdoc_Admin") && !isDraft) {
            this.addButtonEx(
                {
                    callback: lang.hitch(this, this._onClickRleaseIsFinishedCommdoc),
                    internalName: "releaseIsFinished",
                    label: this.translate("CommdocList_ButtonTitle_ReleaseIsFinished"),
                    iconClass: "fas fa-undo",
                    bCloseOnClick: false,
                    enabled: !this.isDirty() && !isDraft,
                    groupname: "documentStatusMenu",
                    position: "secondary",
                }
            );
        } else {
            this.requestContextButtonRemove("releaseIsFinished");
        }
    }

    private _handleReadonlyState(): void {
        let status = this.getAttributeValue("ref_doc_status");
        let isNew = this.getAttributeValue("is_new");
        let signatureEntity = this.getAttributeValue("ref_signature_entity");

        let isNotRelevant = this.getAttributeValue("is_notRelevant");
        let isDraft = this.getAttributeValue("is_draft");
        let isCreated = this.getAttributeValue("is_created");
        let isClosed = this.getAttributeValue("is_closed");
        let isArchived = this.getAttributeValue("is_archived");

        if (!isDraft) {
            this.setReadonly(true);
            if (isCreated) this.setForceCheckDirty(true);
            else this.setForceCheckDirty(false);
            if (this.classEditor) this.classEditor.setReadonly(true);
        }
        if (isClosed || isArchived || isNotRelevant) {
            if (this.digitalSignatureEditor) this.digitalSignatureEditor.setReadonly(true);

        }

    }

    private _onChangeDigitalSignatureEditor(diffData: SignatureEntity): void {
        this.setAttributeValue("signatureEditorDiffData", diffData);
    }

    private _onChangeClassEditor(changeData: any): void {

        if (changeData) {
            let keys = Object.keys(changeData);
            for (let key of keys) {
                this.setAttributeValue(key, changeData[key]);
            }
        }
    }

    private _onClick_EditCommdoc(): void {
        this.StandbyStart();

        let entityID = this.getAttributeValue("ID");

        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__CommDocFinalText_Fetch",
            {
                commdocId: entityID
            },
            lang.hitch(this, this._onEditCommdocResponse, entityID),
            lang.hitch(this, this._onEditCommdocError)
        );
    }

    private docEdit: MdsLax<InstanceType<typeof documentEditor>>;
    private async _onEditCommdocResponse(entityID: string, resp: { base64Content: string, ext: string, isReadOnly: boolean }) {
        this.docEdit = new documentEditor();
        if (resp.isReadOnly == true) {
            this.docEdit.config.isReadOnly = true;
            this.showToast("DocumentEditor_Msg_ReadOnly", "fas fa-lock");
        }
        await this.docEdit.openDocument(atob(resp.base64Content), false, true);
        if (resp.isReadOnly == true) {
            this.docEdit.dlg._setHeaderAttr(this.translate("DocumentEditor_ViewDoc"));
            this.docEdit.dlg.removeButton("save");
            this.docEdit.dlg.keepOpen = false;
        } else {
            //this.docEdit.dlg.keepOpen = true;
        }
        this.docEdit.on("dlgClosedSaved", lang.hitch(this, this.commDocEditor_SaveDocument, entityID));
        this.docEdit.on("dlgClosedClose", lang.hitch(this, () => {
            if (typeof this.docEdit.dlg.keepOpen == 'boolean') {
                if (this.docEdit.dlg.keepOpen == true) {
                    this.docEdit.dlg.close(null, true); //wir muessen manuell schliessen wenn keepOpen true ist...
                }
            }
        }));
        this.StandbyStop();
    }

    private async commDocEditor_SaveDocument(entityID: string) {
        this.docEdit.StandbyStart();
        let sfdt: string;
        try {
            sfdt = await this.docEdit.exportAsSfdt();
        } catch (err) {
            console.error(err);
            this.showToast(this.translate("DocumentEditor_Error_onSave"), "fas fa-exclamation-triangle");
            this.docEdit.StandbyStop();
            return; //wenn das docEditor widget beim laden geschlossen wird, kann nicht gespeichert werden
        }
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_SyncfusionDocumentEditor__CommDocFinalText_Write",
            {
                base64Content: btoa(sfdt),
                commdocId: entityID
            },
            lang.hitch(this, (res) => {
                this.StandbyStop();
                this.docEdit.StandbyStop();
                console.info("document saved", res);
                this.showToast(this.translate("General_Notification_SaveSuccess"), "far fa-save");
            }),
            lang.hitch(this, (err) => {
                this.StandbyStop();
                this.docEdit.StandbyStop();
                console.error(err.Message);
                this.showToast(err.Message, "fas fa-bug");
            })
        );
    }

    private _onEditCommdocError(error): void {
        console.error(error.Message);
        this.showToast(error.Message, "fas fa-exclamation-circle");
        this.StandbyStop();
    }

    private _onClickCreateCommdoc(): void {
        let file = this.getAttributeValue("ref_vt_files");
        let fileLink = this.getAttributeValue("filelink");

        if (file || fileLink) {
            let dlg = new GenericDialog();

            dlg.setup({
                content: "DocumentEditor_Message_CreateDocument",
                header: `${this.translate("DocumentEditor_Heading_CreateDocument")} - ${this.title}`,
                buttonPreset: "yesno",
                contentIconClass: GenericDialogTypes.DialogIcon.warning,
                callbackConfig: {
                    yesCallback: lang.hitch(this, this._sendCreateCommdocRequest)
                }
            })
        } else {
            this._sendCreateCommdocRequest();
        }



       
    }

    private _sendCreateCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname")
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_CreateStatusDocument", requestData, lang.hitch(this, this._onCreateCommdocResponse), lang.hitch(this, this._onCreateCommdocError));
    }

    private _onCreateCommdocResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_CreateStatusDocument", "fas fa-check")
        this._reload();
    }

    private _onCreateCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_CreateStatusDocument", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickGenerateDraftCommdoc(): void {
        let textModules = this.getAttributeValue("EL_ht_text_modul_commdocs_commdoc");

        if (!textModules || textModules?.length <= 0) {
            this.showToast("DocumentEditor_Error_NoTextModules", "fas fa-exclamation-triangle");
            return;
        }

        let final_text = this.getAttributeValue("final_text");

        if (final_text) {
            let dlg = new GenericDialog;
            dlg.setup({
                header: this.translate("DocumentEditor_Heading_GenerateDraft") + " - " + this.title,
                content: "DocumentEditor_Message_OverrideDraft",
                buttonPreset: "yesno",
                contentIconClass: GenericDialogTypes.DialogIcon.warning,
                callbackConfig: {
                    yesCallback: lang.hitch(this, this._sendGenerateDraftCommdocRequest)
                }
            });
        } else {
            this._sendGenerateDraftCommdocRequest();
        }
    }

    private _sendGenerateDraftCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname")
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_GenerateDocumentDraft", requestData, lang.hitch(this, this._onGenerateDraftCommdocResponse), lang.hitch(this, this._onGenerateDraftCommdocError));
    }

    private _onGenerateDraftCommdocResponse(response: {message: string, final_text: string}): void {
        this.StandbyStop();

        this.setAttributeValue("final_text", response.final_text);
        this.resetDirty();

        this.showToast("DocumentEditor_Success_GenerateDocumentDraft", "fas fa-check");
    }

    private _onGenerateDraftCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_GenerateDocumentDraft", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickArchiveCommdoc(): void {
        let dlg = new GenericDialog();
        dlg.setup({
            content: "DocumentEditor_Message_ArchiveCommdoc",
            header: `${this.translate("DocumentEditor_Heading_ArchiveCommdoc")} - ${this.title}`,
            buttonPreset: "yesno",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendArchiveCommdocRequest)
            }
        });
    }

    private _sendArchiveCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname")
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_ArchiveDocument", requestData, lang.hitch(this, this._onArchiveCommdocResponse), lang.hitch(this, this._onArchiveCommdocError));
    }

    private _onArchiveCommdocResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_ArchiveDocument", "fas fa-check");
        this._reload();
    }

    private _onArchiveCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_ArchiveDocument", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickRleaseIsFinishedCommdoc(): void {
        let dlg = new GenericDialog();
        dlg.setup({
            content: "DocumentEditor_Message_ReleaseIsFinishedDocument",
            header: `${this.translate("DocumentEditor_Heading_ReleaseIsFinishedDocument")} - ${this.title}`,
            buttonPreset: "yesno",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendRleaseIsFinishedCommdocRequest)
            }
        });
    }

    private _sendRleaseIsFinishedCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname")
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_ReleaseIsFinished", requestData, lang.hitch(this, this._onRleaseIsFinishedCommdocResponse), lang.hitch(this, this._onRleaseIsFinishedCommdocError));
    }

    private _onRleaseIsFinishedCommdocResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_ReleaseIsFinishedDocument", "fas fa-check");
        this._reload();
    }

    private _onRleaseIsFinishedCommdocError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_ReleaseIsFinishedDocument", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _onClickCloseCommdoc(): void {
        let dlg = new GenericDialog();
        dlg.setup({
            content: "DocumentEditor_Message_CloseCommdoc",
            header: `${this.translate("DocumentEditor_Heading_CloseCommdoc")} - ${this.title}`,
            buttonPreset: "yesno",
            contentIconClass: GenericDialogTypes.DialogIcon.warning,
            callbackConfig: {
                yesCallback: lang.hitch(this, this._sendCloseCommdocRequest)
            }
        });
    }

    private _sendCloseCommdocRequest(): void {
        this.StandbyStart();
        let requestData = {
            ID: this.getAttributeValue("ID"),
            Classname: this.getAttributeValue("Classname")
        }

        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_CloseDocument", requestData, lang.hitch(this, this._onCommdocCloseResponse), lang.hitch(this, this._onCommdocCloseError));
    }

    private _onCommdocCloseResponse(response): void {
        this.StandbyStop();

        this.emit("saved");
        this.showToast("DocumentEditor_Success_CloseDocument", "fas fa-check");
        this._reload();
    }

    private _onCommdocCloseError(error: more.requestErrorMessage): void {
        this.StandbyStop();
        this.showToast({ title: "DocumentEditor_Error_CloseDocument", message: error?.Message, iconClass: "fas fa-exclamation-triangle", timeout: "permanent", showClose: true });
        console.error(error);
    }

    private _onClickCreateSignatureObject(): void {
        this.StandbyStart();

        let document = this.getAttributeValue("___root");
        this.RequestManager.callfunction("Webtool_API_Document__DocumentEditor_CreateSignatureObject", { document }, lang.hitch(this, this._onCreateSignatureObjectResponse), lang.hitch(this, this._onCreateSignatureObjectError));
    }

    private _onCreateSignatureObjectResponse(response): void {
        this.StandbyStop();
        this.emit("saved");
        this.showToast("DocumentEditor_Success_CreateSignatureObject", "fas fa-check");
        this._reload();
    }

    private _onCreateSignatureObjectError(error): void {
        this.StandbyStop();
        this.showToast("DocumentEditor_Error_CreateSignatureObject", "fas fa-exclamation-triangle");
        console.error(error);
    }

    private _reload(): void {
        let id = this.getAttributeValue("ID");
        if (!id) return;
        this._loadEntity(id);
    }

    //UIFRAMEMIXIN
    _onCloseRequest() {
        let hasChanged = this.isDirty() === true;

        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translate("Document_DocumentEditor_AskSavePendingChanges"),
                this.translate("General_PendingChanges") + " - " + this.title,
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.emit("notSaved");
            this.close();
        } else if (result == 0) { // cancel
            this.emit("canceled");
        }
        else {
            this._onClickSave();
            this.on("saved", lang.hitch(this, this.close));
        }
    }

    //SED
    private _onClickSEDButton(mode: string, evt: MouseEvent) {
        this.loadSelectEntityDialog(evt, mode, lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<DocumentAddress | EvService | TextModule>>) {
        let entity;
        if (items && items.length >= 0) entity = items[0].entry.data;
        else return;

        switch (mode) {
            case "editor":
                this.setAttributeValue("ref_editor", entity);
                break;
            case "selectTextModule":
                for (let item of items) {
                    entity = item.entry.data as TextModule;
                    this._addTextModuleToStore(entity);
                }
                break;
            case "selectService":
                for (let item of items) {
                    entity = item.entry.data as EvService;
                    this._addPosEvServToStore(entity);
                }
                break;
        }
    }

    //WIDGETBASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_Document__DocumentEditor_GetSEDConfig";

        this.inputEditorAddress.addInlineButton(lang.hitch(this, this._onClickSEDButton, "editor"));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CommdocEditor);